import type { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/cart/get';
import { postToHamsClient } from 'util/mac/api/cart/post';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { selectSwitchedUser } from '../selectors';

export const source = (sourceParam: string, state: State) =>
  fetchWithParamValidation((src) => postToHamsClient('', state, undefined, { source: src }), {
    src: sourceParam,
  });

export const purchaseOrderNumberUpdate = (
  cartId: string,
  purchaseOrderNumberParam: string,
  state: State,
  hash?: string,
) => {
  const email = selectSwitchedUser(state);

  return fetchWithParamValidation(
    ({ identifier, updByEmail, PONum }) =>
      postToHamsClient(
        `/${identifier}/purchaseOrderNumber?purchaseOrderNumber=${PONum}&updatedByEmail=${updByEmail}&hash=${hash}`,
        state,
        {},
      ),
    { identifier: cartId, PONum: purchaseOrderNumberParam, updByEmail: email },
  );
};

export const cartByOrderNumber = (orderNumber: number, state: State, hash?: string) => {
  const url = hash ? `/order/${orderNumber}?hash=${hash}` : `/order/${orderNumber}`;
  return fetchWithParamValidation(() => getFromHamsClient(url, state), {});
};
